export { GoalResult } from './GoalResult';
